import React, { useEffect } from 'react';
import "./HeaderSlider.scss";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAsyncBanners, getBanners, getBannersStatus } from '../../store/bannerSlice'; // Import des actions
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Loader from "../Loader/Loader"; // Assurez-vous d'avoir un Loader si nécessaire
import { IMAGE_URL1 } from "../../utils/apiURL";

const HeaderSlider = () => {
  const dispatch = useDispatch();
  const banners = useSelector(getBanners);  // Sélecteur pour récupérer les bannières
  const bannersStatus = useSelector(getBannersStatus);  // Sélecteur pour vérifier le statut des bannières

  // Paramètres du slider ajustés pour n'afficher qu'une seule image à la fois
  const settings = {
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Afficher une seule image
    slidesToScroll: 1 // Faire défiler une seule image
  };

  // Utilisation de useEffect pour récupérer les bannières
  useEffect(() => {
    dispatch(fetchAsyncBanners());  // Appel à l'action pour charger les bannières
  }, [dispatch]);

  // Affichage conditionnel en fonction du statut des bannières
  if (bannersStatus === 'loading') {
    return <Loader />;
  }

  if (bannersStatus === 'failed') {
    return <div className="error">Error loading banners.</div>;
  }

  return (
    <div className='slider'>
      <div className='container'>
        <div className='slider-content overflow-x-hidden'>
          <Slider {...settings}>
            {/* Si des bannières existent, afficher la première bannière et faire défiler les autres */}
            {banners.map((banner) => (
              <div key={banner.id} className='slider-item'>
                <img src={`${IMAGE_URL1}${banner.image_url}`} alt={banner.title} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default HeaderSlider;
